// extracted by mini-css-extract-plugin
module.exports = {"container":"values-module--container--3E_C5","avg":"values-module--avg--10sYQ","minmax":"values-module--minmax--1FJN-"};